import SearchChips from 'components/SearchChips/SearchChips';
import SectionHeader from 'components/SectionHeader/SectionHeader';
import SelectTimePeriod from 'components/SearchInputs/SelectTimePeriod';
import SelectUmpireLeagues from 'components/SearchInputs/SelectUmpireLeagues';
import SelectUmpires from 'components/SearchInputs/SelectUmpires';
import { useReportId } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';
import useUmpireAllSessionsReport from 'hooks/UmpireReport/AllSessions/useUmpireAllSessionsReport';

type Props = {
  isSearchCriteriaOpen: boolean;
  setSearchCriteriaOpen: () => void;
};

const AllSessionsSearchCriteria = ({ isSearchCriteriaOpen, setSearchCriteriaOpen }: Props) => {
  const { isCreate } = useReportId();

  const { searchCriteria, setSearchCriteria, searchChips } = useUmpireAllSessionsReport();

  const { t } = useTranslation();

  return (
    <>
      <SectionHeader
        isOpen={isSearchCriteriaOpen}
        onClick={isCreate ? setSearchCriteriaOpen : undefined}
        title={t('Populate report')}
        isEnabled={isCreate}
      />
      {isSearchCriteriaOpen ? (
        <div className='report-layout-shelf-section'>
          <SelectTimePeriod
            selectedSeasonNames={searchCriteria.seasonNames}
            onChange={(seasonNames, dateRanges) =>
              setSearchCriteria({
                dateRanges,
                seasonNames,
                leagues: undefined,
                umpires: undefined,
              })
            }
          />
          <SelectUmpireLeagues
            selectedLeagues={searchCriteria.leagues}
            onChange={(leagues) => setSearchCriteria({ leagues, umpires: undefined })}
            dateRanges={searchCriteria.dateRanges}
          />
          <SelectUmpires
            selectedUmpires={searchCriteria.umpires}
            onChange={(umpires) => setSearchCriteria({ umpires })}
            dateRanges={searchCriteria.dateRanges}
            leagueIds={searchCriteria.leagues?.map((league) => league.id)}
          />
        </div>
      ) : (
        searchChips.dateRanges && (
          <SearchChips
            seasonNames={searchChips.seasonNames}
            dateRanges={searchChips.dateRanges}
            otherChips={{ ...searchChips, dateRanges: undefined, seasonNames: undefined }}
          />
        )
      )}
    </>
  );
};

export default AllSessionsSearchCriteria;
